import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

// import QuoteRoom from './components/QuoteRoom/QuoteRoom'
// import QuoteDetail from './components/QuoteDetail/QuoteDetail'
// import SelectContractor from './components/QuoteContractor/SelectContractor';
// import ItemDetail from './components/QuoteContractor/ItemDetail';
// import QuoteDesignerPm from './components/QuoteDesignerPm/QuoteDesignerPm';
// import ConfirmQuotes from './components/Confirm/ConfirmQuotes';
// import Success from './components/Success/Success';

// // import Homepage from './components/Homepage/Home';
// import Homepage from './components/NewHomepage/NewHome'
// import ListContractor from './components/Vendor/ListContractor';
// import ListDesigner from './components/Vendor/ListDesigner';
// import DesignerDetail from './components/Vendor/DesignerDetail'
// import MyQuotes from './components/MyQuotes/MyQuotes';
// import MyQuoteDetail from './components/MyQuotes/MyQuoteDetail';
// import ContractorDetail from './components/Vendor/ContractorDetail';
// import MyProfile from './components/MyProfile'

// import Privacy from './components/Static/Privacy'
// import Term from './components/Static/Term'
// // import AboutUs from './components/AboutUs'
// import AboutUs from './components/AboutUs/About'
// import ContactUs from './components/ContactUs'
// import Register from './components/Register'

// import ActiveEmail from './components/MainOther/ActiveEmail'
// import ResetPassword from './components/MainOther/ResetPassword'
// import ListPm from './components/Vendor/ListPm';
// import PMDetail from './components/Vendor/PMDetail';
// import Supplier from './components/Static/Supplier';
// import Tools from './components/Static/Tools';
// import Tutorial from './components/Static/Tutorial';
// import Faq from './components/Faq';

import Header from './components/Common/Header'
import MainCustomer from './components/MainCustomer/MainCustomer';
import MainApp from './components/MainApp/MainApp'
import MainHome from './components/MainHome/MainHome';
import MainOther from './components/MainOther'
import MainNoAds from './components/MainNoAds'
import Loadable from 'react-loadable';

// import SuplierList from './components/Suplier/List'
import SuplierDetail from './components/Suplier/Detail'
import SeoPage from './components/SeoPage'

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <Route {...rest} render={props => (
        <Header>
            <Layout>
                <Component {...props} />
            </Layout>
        </Header>
    )} />
)

const AppRouteAds = ({ component: Component, layout: Layout, ...rest }) => (
    <Route {...rest} render={props => (
        <Layout>
            <Component {...props} />
        </Layout>
    )} />
)

const loadAsync = (opts) => {
    return Loadable(Object.assign({
        loading: () => {
            return (
                <div>...Loading</div>
            )
        }
    }, opts));
}

export default () => {
    return (
        <BrowserRouter>
           
                <Switch>
                    {/* <AppRoute exact path="/quotes/detail" layout={MainApp} component={QuoteDetail} />
                    <AppRoute exact path="/quotes/detail/:quote_id" layout={MainApp} component={QuoteDetail} />
                    <AppRoute path="/quotes/room/:quote_id" layout={MainApp} component={QuoteRoom} />
                    <AppRoute path="/quotes/contractor/:quote_id" layout={MainApp} component={SelectContractor} />
                    <AppRoute path="/quotes/designer-pm/:quote_id" layout={MainApp} component={QuoteDesignerPm} />
                    <AppRoute path="/quotes/confirm/:quote_id" layout={MainApp} component={ConfirmQuotes} />
                    <AppRoute path="/quotes/success/:quote_id" layout={MainApp} component={Success} />
                    <AppRoute path="/quotes/items/:quote_id/:group_id" layout={MainHome} component={ItemDetail} />

                    <AppRouteAds exact path="/" layout={MainNoAds} component={Homepage} />
                    <AppRoute exact path="/contractors" layout={MainHome} component={ListContractor} />
                    <AppRoute exact path="/contractor/:contractor_id" layout={MainHome} component={ContractorDetail} />
                    <AppRoute exact path="/designers" layout={MainHome} component={ListDesigner} />
                    <AppRoute exact path="/designer/:designer_id" layout={MainHome} component={DesignerDetail} />
                    <AppRoute exact path="/project-managers" layout={MainHome} component={ListPm} />
                    <AppRoute exact path="/pm/:pm_id" layout={MainHome} component={PMDetail} />
                    <AppRoute exact path="/my-quotes" layout={MainCustomer} component={MyQuotes} />
                    <AppRoute exact path="/quotes/:quote_id" layout={MainCustomer} component={MyQuoteDetail} />

                    <AppRouteAds exact path="/about-us" layout={MainNoAds} component={AboutUs} />
                    <AppRoute exact path="/contact-us" layout={MainHome} component={ContactUs} />
                    <AppRoute exact path="/privacy-policy" layout={MainHome} component={Privacy} />
                    <AppRoute exact path="/term-conditions" layout={MainHome} component={Term} />
                    <AppRoute exact path="/supplier" layout={MainHome} component={SuplierList} /> */}
                    {/* <AppRoute exact path="/tools" layout={MainHome} component={Tools} /> */}
                    {/* <AppRoute exact path="/tutorial" layout={MainHome} component={Tutorial} /> */}
                    {/* <AppRoute exact path="/faq" layout={MainHome} component={loadAsync({ loader: () => import('./components/Faq') })} /> */}

                    <AppRoute exact path="/register" layout={MainHome} component={loadAsync({ loader: () => import('./components/Register') })} />

                    <AppRoute exact path="/profile" layout={MainCustomer} component={loadAsync({ loader: () => import('./components/MyProfile') })}/>

                    <AppRoute path="/register/verify/:code" layout={MainOther} component={loadAsync({ loader: () => import('./components/MainOther/ActiveEmail') })}/>
                    <AppRoute path="/password/reset/:code" layout={MainOther} component={loadAsync({ loader: () => import('./components/MainOther/ResetPassword') })}/>

                    {/* <AppRoute exact path="/quotes/detail" layout={MainApp} component={loadAsync({ loader: () => import('./components/QuoteDetail/QuoteDetail') })} />
                    <AppRoute exact path="/quotes/detail/:quote_id" layout={MainApp} component={loadAsync({ loader: () => import('./components/QuoteDetail/QuoteDetail') })} /> */}
                    <AppRoute path="/quotes/room/:quote_id" layout={MainApp} component={loadAsync({ loader: () => import('./components/QuoteRoom/QuoteRoom') })} />
                    <AppRoute path="/quotes/contractor/:quote_id" layout={MainApp} component={loadAsync({ loader: () => import('./components/QuoteContractor/SelectContractor') })} />
                    <AppRoute path="/quotes/designer-pm/:quote_id" layout={MainApp} component={loadAsync({ loader: () => import('./components/QuoteDesignerPm/QuoteDesignerPm') })} />
                    <AppRoute path="/quotes/confirm/:quote_id" layout={MainApp} component={loadAsync({ loader: () => import('./components/Confirm/ConfirmQuotes') })} />
                    <AppRoute path="/quotes/success/:quote_id" layout={MainApp} component={loadAsync({ loader: () => import('./components/Success/Success') })} />
                    <AppRoute path="/quotes/items/:quote_id/:group_id" layout={MainHome} component={loadAsync({ loader: () => import('./components/QuoteContractor/ItemDetail') })} />

                    <AppRouteAds exact path="/" layout={MainNoAds} component={loadAsync({ loader: () => import('./components/NewHomepage/NewHome') })} />
                    {/* <AppRoute exact path="/contractors" layout={MainHome} component={loadAsync({ loader: () => import('./components/Vendor/ListContractor') })} /> */}
                    <AppRoute exact path="/contractor/:contractor_id" layout={MainHome} component={loadAsync({ loader: () => import('./components/Vendor/ContractorDetail') })} />
                    {/* <AppRoute exact path="/designers" layout={MainHome} component={loadAsync({ loader: () => import('./components/Vendor/ListDesigner') })} /> */}
                    <AppRoute exact path="/designer/:designer_id" layout={MainHome} component={loadAsync({ loader: () => import('./components/Vendor/DesignerDetail') })} />
                    {/* <AppRoute exact path="/project-managers" layout={MainHome} component={loadAsync({ loader: () => import('./components/Vendor/ListPm') })} /> */}
                    <AppRoute exact path="/pm/:pm_id" layout={MainHome} component={loadAsync({ loader: () => import('./components/Vendor/PMDetail') })} />
                    <AppRoute exact path="/my-quotes" layout={MainCustomer} component={loadAsync({ loader: () => import('./components/MyQuotes/MyQuotes') })} />
                    <AppRoute exact path="/quotes/:quote_id" layout={MainCustomer} component={loadAsync({ loader: () => import('./components/MyQuotes/MyQuoteDetail') })} />

                    {/* <AppRouteAds exact path="/about-us" layout={MainNoAds} component={loadAsync({ loader: () => import('./components/AboutUs/About') })} /> */}
                    <AppRoute exact path="/contact-us" layout={MainHome} component={loadAsync({ loader: () => import('./components/ContactUs') })} />
                    {/* <AppRoute exact path="/privacy-policy" layout={MainHome} component={loadAsync({ loader: () => import('./components/Static/Privacy') })} /> */}
                    {/* <AppRoute exact path="/term-conditions" layout={MainHome} component={loadAsync({ loader: () => import('./components/Static/Term') })} /> */}
                    <AppRoute exact path="/supplier" layout={MainHome} component={loadAsync({ loader: () => import('./components/Suplier/List') })} />
                    <AppRoute exact path="/blogs" layout={MainHome} component={loadAsync({ loader: () => import('./components/Blog') })} />
                    <AppRoute exact path="/supplier/:suplier_id" layout={MainHome} component={SuplierDetail} />

                    <AppRoute exact path="/:page_slug" layout={MainHome} component={SeoPage} />

                    {/* <AppRoute exact path="/blog/:blog_id" layout={MainHome} component={loadAsync({ loader: () => import('./components/Blog/Detail') })} /> */}

                    {/* <AppRoute exact path="/suplier" layout={MainHome} component={SuplierList} /> */}
                    
                    

                </Switch>
           
        </BrowserRouter>
    )
}